import _asyncToGenerator from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createSuper";
import _defineProperty from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import Gikam from '../../core/gikam-core.js';
import Base from '../base.js';
import { I18N } from '@/gikam/i18n/I18N.js';
var defaultOptions = {
  iframe: null,
  version: null,
  fileType: null,
  fileName: null,
  fileUrl: null,
  mode: 'view',
  viewType: 'modal',
  callbackUrl: null,
  popupIsModal: true,
  otherParam: {
    download: true,
    print: true
  },
  saved: true,
  onAfterClose: Gikam.emptyFunction
};

var CustomEditorOffice = /*#__PURE__*/function (_Base) {
  _inherits(CustomEditorOffice, _Base);

  var _super = _createSuper(CustomEditorOffice);

  function CustomEditorOffice(options) {
    var _this2;

    _classCallCheck(this, CustomEditorOffice);

    _this2 = _super.call(this);

    _defineProperty(_assertThisInitialized(_this2), "getInfo", function () {
      return Gikam.getJson("".concat(Gikam.IFM_CONTEXT, "/secure/core/module/office/customizations/configs"));
    });

    _defineProperty(_assertThisInitialized(_this2), "getToolbarMenu", function (ext) {
      var officeCategory = this.convertExt2Type(ext);

      if (officeCategory === false) {
        return;
      }

      var url = Gikam.printf("".concat(Gikam.IFM_CONTEXT, "/secure/core/module/office/toolbars/queries/category/{officeCategory}"), {
        officeCategory: officeCategory.toString().toLowerCase()
      });
      return Gikam.post(url);
    });

    _defineProperty(_assertThisInitialized(_this2), "getDataSource", function () {
      var url = "".concat(Gikam.IFM_CONTEXT, "/secure/core/module/office/dses/tree/queries");
      return Gikam.getJson(url);
    });

    _defineProperty(_assertThisInitialized(_this2), "convertExt2Type", function (ext) {
      var supportType = [{
        code: 'WORD',
        typeArray: ['doc', 'docm', 'docx', 'dot', 'dotm', 'dotx', 'epub', 'fodt', 'htm', 'html', 'mht', 'odt', 'ott', 'pdf', 'rtf', 'txt', 'djvu', 'xps']
      }, {
        code: 'EXCEL',
        typeArray: ['csv', 'fods', 'ods', 'ots', 'xls', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xltx']
      }, {
        code: 'PRESENTATION',
        typeArray: ['fodp', 'odp', 'otp', 'pot', 'potm', 'potx', 'pps', 'ppsm', 'ppsx', 'ppt', 'pptm', 'pptx']
      }];

      for (var i = 0; i < supportType.length; i++) {
        var typeArray = supportType[i].typeArray;

        if (typeArray.includes(ext)) {
          return supportType[i].code;
        }
      } // 不做处理


      return false;
    });

    _defineProperty(_assertThisInitialized(_this2), "getFormats", function (formats, fileType) {
      var data = JSON.parse(formats);
      var type = this.convertExt2Type(fileType);

      if (type === 'WORD') {
        return data.word && data.word.split(',') || [];
      }

      if (type === 'EXCEL') {
        return data.excel && data.excel.split(',') || [];
      }

      return [];
    });

    _defineProperty(_assertThisInitialized(_this2), "formatData", function (data) {
      var result = [];

      for (var i = 0; i < data.length; i++) {
        var item = {};
        var subMenu = {};
        var parent = data[i];
        var children = parent.toolbarLineList;

        for (var j = 0; j < children.length; j++) {
          subMenu[children[j].menuCode] = !Number(children[j].lastSuspendedFlag);
        }

        item[parent.menuCategoryCode] = !Number(parent.lastSuspendedFlag);
        item.subMenu = subMenu;
        result.push(item);
      }

      return result;
    });

    _this2.getListeners();

    options.viewType = options.otherParam && options.otherParam.viewType ? options.otherParam.viewType : options.viewType;

    _this2.initialize(options, defaultOptions).init();

    return _this2;
  }
  /**
   * @description 可配置钩子函数
   * @private
   * @memberof EditorOffice
   */


  _createClass(CustomEditorOffice, [{
    key: "getListeners",
    value: function getListeners() {
      this.listeners = {
        warn: Gikam.emptyFunction,
        error: Gikam.emptyFunction
      };
    }
    /**
     * @description 加载sunwayoffice组件
     * @private
     * @memberof sunwayoffice
     */

  }, {
    key: "loadDocEditor",
    value: function loadDocEditor() {
      //监听加载状态
      this.iframe.onload = function () {
        //加载完毕初始化编辑页面
        this.iframe.contentWindow.initDocEditorPage(this.serverUrl, this.editorOfficeObj, this.officeHook);
      }.bind(this); //监听编辑页面无法加载时的情况


      this.iframe.onerror = function () {
        Gikam.alert(I18N.prop("office.file.editor.not.find.tip"));
        this.trigger('error');
        this.destroy();
      }.bind(this);
    }
    /**
     * @description 初始化组件参数
     * @private
     * @memberof sunwayoffice
     */
    // eslint-disable-next-line complexity

  }, {
    key: "initParams",
    value: function () {
      var _initParams = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var fileDetailCompleted, needCustomer, type, callbackUrl;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //判断文件数据是否完整
                fileDetailCompleted = true; //判断时候需要定制化logo

                needCustomer = true; //判断使用桌面模式还是移动模式

                type = 'desktop';
                if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) type = 'mobile'; //获取sunwayoffice服务地址

                this.serverUrl = Gikam.sunwayoffice.serverUrl || Gikam.IFM_CONTEXT;
                _context.next = 7;
                return this.getInfo().done(function (result) {
                  _this3.options.customer = {
                    address: result.address,
                    info: result.info,
                    logo: "".concat(Gikam.IFM_CONTEXT).concat(result.aboutLogo),
                    // 关于中的公司logo地址， png格式的推荐大小为432*70
                    mail: result.mail,
                    name: result.name,
                    www: result.www
                  };
                  _this3.options.logo = {
                    image: "".concat(Gikam.IFM_CONTEXT).concat(result.logo) // logo地址， 推荐大小172*40
                    // url: result.logoUrl // 点击logo跳转地址

                  };
                  _this3.options.formats = _this3.getFormats(result.downloadAs, _this3.options.fileType);
                }).catch(function () {
                  // 暂时不需要处理, 没有就显示sunwayoffice的默认值
                  needCustomer = false;
                });

              case 7:
                _context.next = 9;
                return this.getToolbarMenu(this.options.fileType).done(function (result) {
                  _this3.options.menu = _this3.formatData(result.rows);
                  _this3.iframe.src = "".concat(Gikam.IFM_CONTEXT, "/static/plugin/sunwayoffice/office.html");
                }).fail(function () {
                  _this3.destroy();

                  fileDetailCompleted = false;
                  Gikam.alert(I18N.prop('office.file.info.not.find.tip'));
                });

              case 9:
                if (!(this.options.otherParam && this.options.otherParam.officeTmplId)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 12;
                return this.getDataSource().done(function (result) {
                  _this3.options.dataSourceData = result;
                  _this3.options.templId = _this3.options.otherParam.officeTmplId;
                }).fail(function () {});

              case 12:
                if (fileDetailCompleted) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return");

              case 14:
                callbackUrl = this.options.callbackUrl; // Word/Excel/ELN编辑时回调地址， 其他情况为上述默认地址

                if (this.options.otherParam && this.options.otherParam.officeTmplId) {
                  if (this.options.otherParam && this.options.otherParam.eln) {
                    // ELN模板生成的报告编辑
                    callbackUrl = "".concat(callbackUrl, "?service=coreOfficeELNInvokeConsumer&tmplId=").concat(this.options.otherParam.officeTmplId);
                  } else {
                    // Word/Excel/ELN报告模板编辑
                    callbackUrl = "".concat(callbackUrl, "?service=coreOfficeTmplInvokeConsumer&tmplId=").concat(this.options.otherParam.officeTmplId);
                  }
                } //配置office编辑器所需参数


                this.editorOfficeObj = {
                  //文档参数
                  document: {
                    //文件类型
                    fileType: this.options.fileType.toLowerCase(),
                    //文件ID
                    key: this.options.key || new Date().valueOf().toString(),
                    //文件名称
                    title: this.options.fileName,
                    //文件下载地址
                    url: Gikam.isTrue(Gikam.sunwayoffice.watermarkEnable) ? this.options.fileUrl.replace(this.options.fileName, encodeURIComponent(this.options.fileName + '_REVERT_WATERMARK_BAK')) : this.options.fileUrl,
                    permissions: {
                      download: this.options.otherParam.download,
                      // 下载按钮，默认true，传入false会隐藏
                      print: this.options.otherParam.print,
                      //打印按钮，默认true，传入false会隐藏
                      comment: this.options.otherParam.comment === false ? false : true // 传入false禁止批注功能

                    }
                  },
                  //编辑器参数
                  editorConfig: {
                    lang: Gikam.locale === 'en-US' ? 'en' : 'zh-CN',
                    // 传了回调的保存接口后，直接调用，不传就用核心的
                    callbackUrl: callbackUrl,
                    ///编辑模式（view : 查看 | edit : 编辑）
                    mode: this.options.mode,
                    // 工作流程对应的文本控制标签, 值是数组, 如果不传值, 默认都能修改, 都不能修改则对应的是mode = 'view'预览模式
                    workflow: this.options.otherParam.workflow || [],
                    dataSourceData: this.options.dataSourceData || {},
                    // 数据源数据
                    customization: {
                      spellcheck: false,
                      // 不开启拼写检查
                      forcesave: true,
                      // 默认配置, 修改慎重修改, 此处是把office.html文件中的默认值给移到此处
                      help: false,
                      // 默认配置, 修改慎重修改, 此处是把office.html文件中的默认值给移到此处
                      customer: this.options.customer || {},
                      logo: this.options.logo || {},
                      trackChanges: Gikam.isTrue(this.options.otherParam.trackChanges) ? true : false,
                      trackChangesOperation: Gikam.isFalse(this.options.otherParam.trackChangesOperation) ? false : true
                    },
                    menu: this.options.menu || [],
                    waterMark: Gikam.isTrue(Gikam.sunwayoffice.watermarkEnable) ? true : false,
                    waterMarkConfig: this.options.otherParam.waterMarkConfig,
                    downloadCountUrl: this.options.downloadCountUrl || '',
                    // 记录下载次数
                    printCountUrl: this.options.printCountUrl || '',
                    // 记录打印次数
                    formats: this.options.formats,
                    // 自定义文件-下载为中的文件下载格式
                    templId: this.options.templId || ''
                  },
                  type: type
                }; // 不需要定制化信息时, 删除定制化信息配置

                if (!needCustomer) {
                  delete this.editorOfficeObj.editorConfig.customization.customer;
                  delete this.editorOfficeObj.editorConfig.customization.logo;
                }

                this.editorOfficeObj.editorConfig.user = {};

                if (window.workspace.user.userName) {
                  this.editorOfficeObj.editorConfig.user.name = window.workspace.user.userName;
                }

                if (window.workspace.user.id) {
                  this.editorOfficeObj.editorConfig.user.id = window.workspace.user.id;
                } // 预览模式下且能添加评论配置


                if (this.options.mode === 'view' && this.options.otherParam.comment !== false) {
                  this.editorOfficeObj.document.permissions.edit = false;
                  this.editorOfficeObj.editorConfig.mode = 'edit';
                } // 预览模式下，不能添加评论配置


                if (this.options.mode === 'view' && this.options.otherParam.comment === false) {
                  this.editorOfficeObj.editorConfig.callbackUrl = '';
                } // 只能修改文本控制区域的内容， 且不可删除文本控制区域


                if (this.options.otherParam.fillForms === true) {
                  this.editorOfficeObj.document.permissions.edit = false;
                  this.editorOfficeObj.document.permissions.comment = false;
                  this.editorOfficeObj.editorConfig.mode = 'edit';
                  this.editorOfficeObj.document.permissions.fillForms = true;
                }

                this.options.viewType !== 'blank' && this.loadDocEditor();

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initParams() {
        return _initParams.apply(this, arguments);
      }

      return initParams;
    }()
    /**
     * @description 获取定制化的logo信息及关于里面的公司信息
     * @private
     * @memberof EditorOffice
     */

  }, {
    key: "initEditorContainer",
    value:
    /**
     * @description 初始化iframe容器
     * @private
     * @memberof sunwayoffice
     */
    function initEditorContainer() {
      var _this4 = this;

      var excludeUrlArray = ['https://localhost', 'http://localhost', 'localhost', 'https://127.0.0.1', 'http://127.0.0.1', '127.0.0.1'];
      var valid = excludeUrlArray.some(function (item) {
        return Gikam.sunwayoffice.downloadUrl.startsWith(item);
      });

      if (valid) {
        Gikam.alert('GIKAM.OFFICE.TIP.DO_NOT_USE_LOCALHOST');
        return;
      }

      if (this.options.viewType === 'modal') {
        var tempMeta = document.getElementsByTagName('meta')[1];
        tempMeta.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, minimal-ui');

        var _this = this;

        this.modal = Gikam.create('modal', {
          title: I18N.prop('office.file.edit.modal.title'),
          src: 'about:blank',
          isModal: Gikam.isFalse(_this.options.popupIsModal) ? false : true,
          onAfterClose: function onAfterClose() {
            tempMeta.setAttribute('content', 'width=device-width, initial-scale=0.6, maximum-scale=0.6, minimum-scale=0.6, user-scalable=no');

            if (typeof _this.options.onAfterClose === 'function') {
              _this.options.onAfterClose();
            }
          }
        });
        this.iframe = this.modal.getIframeDom();
      } else if (this.options.viewType === 'iframe') {
        this.iframe = this.options.iframe;
      } else if (this.options.viewType === 'blank') {
        this.iframe = window.open("".concat(location.href, "static/plugin/sunwayoffice/office.html"));
        this.iframe.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this4.iframe.document.title = _this4.options.fileName;
                  _context2.next = 3;
                  return _this4.initParams();

                case 3:
                  _this4.iframe.initDocEditorPage(_this4.serverUrl, _this4.editorOfficeObj, _this4.officeHook);

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
      }

      if (!this.iframe) {
        this.destroy();
        Gikam.alert(I18N.prop('office.load.iframe.error.tip'));
      }
    }
    /**
     * @description 初始化sunwayoffice自用钩子函数
     * @private
     * @memberof sunwayoffice
     */

  }, {
    key: "initOfficeHookFunction",
    value: function initOfficeHookFunction() {
      var _this = this; //组件错误时调用


      var errorFunc = function errorFunc(event) {
        if (event.data.errorCode == -4) {
          Gikam.alert(I18N.prop("office.file.download.error.tip"));
        } else {
          Gikam.alert(I18N.prop("office.file.service.error.tip"));
        }

        Gikam.error("".concat(I18N.prop('office.error.code'), ": ").concat(event.data.errorCode, " -------- ").concat(I18N.prop('office.error.message'), ": ").concat(event.data.errorDescription));

        _this.trigger('error', event);

        _this.destroy();
      }; //组件警告时调用


      var warningFunc = function warningFunc(event) {
        if (!event.data.warningCode) return;
        Gikam.warn("".concat(I18N.prop('office.warning.code'), ": ").concat(event.data.warningCode, " -------- ").concat(I18N.prop('office.waring.message'), ": ").concat(event.data.warningDescription));

        _this.trigger('warn', event);
      }; //无法获取sunwayoffice服务器api.js时调用


      var onScriptError = function onScriptError() {
        Gikam.alert(I18N.prop("office.load.iframe.error.tip"));

        _this.trigger('error');

        _this.destroy();
      }; //将应用程序加载到浏览器时调用的函数


      var onAppReady = Gikam.emptyFunction; //将文档加载到文档编辑器中时调用的函数

      var onDocumentReady = Gikam.emptyFunction; //修改文档时调用的函数, event.data为true时, 表示正在保存, 为false时, 表示保存完毕
      // 一次修改会触发两次此方法

      var onDocumentStateChange = function onDocumentStateChange(event) {
        _this.saved = !event.data;
      };

      this.officeHook = {
        onError: errorFunc,
        onWarning: warningFunc,
        onScriptError: onScriptError,
        onAppReady: onAppReady,
        onDocumentReady: onDocumentReady,
        onDocumentStateChange: onDocumentStateChange
      };
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (Gikam.isSunwayOfficeSupport(this.options.fileType)) {
                  _context3.next = 3;
                  break;
                }

                Gikam.alert(I18N.prop('office.file.not.open'));
                return _context3.abrupt("return");

              case 3:
                this.initOfficeHookFunction();
                this.initEditorContainer();
                this.initParams();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
    /**
     * @description 关闭编辑页面
     * @private
     * @memberof sunwayoffice
     */

  }, {
    key: "destroy",
    value: function destroy() {
      if (this.modal) this.modal.close();
      if (this.iframe) this.iframe.src = '';
    }
  }]);

  return CustomEditorOffice;
}(Base);

export { CustomEditorOffice as default };